/**
 * All-in-one service (permission) keys.
 *
 * These are the exact keys returned by `GET /api/auth/me` in `all_in_one_services`
 * and `permissions`. They gate both the sidebar buttons and the module routes, so
 * they must stay in sync with the service names configured on the backend.
 *
 * Note: `simfix_areas` is the SIMFIX module and `semafix` is the separate SEMAFIX
 * module — they are two different products despite the similar names.
 */
export const SERVICE_KEYS = {
  fcd_network: 'fcd_network',
  simfix_areas: 'simfix_areas',
  predict: 'predict',
  tl_green_wave: 'tl_green_wave',
  signalfix: 'signalfix',
  od_analysis: 'od_analysis',
  assignx: 'assignx',
  mystery_client: 'mystery_client',
  semafix: 'semafix',
};

/** Every module permission key, used when counting the modules a user can open. */
export const MODULE_SERVICE_KEYS = Object.values(SERVICE_KEYS);
